// UI

// MEAL TYPE
export const LEISURE_MEAL_TEXT = "Moment détente";
export const PROFESSIONAL_MEAL_TEXT = "Repas professionel";
export const FAST_MEAL_TEXT = "Repas rapide";
export const BIRTHDAY_MEAL_TEXT = "Anniversaire";
export const SPECIAL_MEAL_TEXT = "Événement particulier";
export const OTHER_MEAL_TEXT = "Autre";

// SETTINGS
export const RESTAURANT_NAME_TEXT = "Nom du restaurant";
export const RESTAURANT_ADDRESS_TEXT = "Adresse du restaurant";

// RESERVATION
export const eventTypes = [
    { key: "LEISURE", value: "LEISURE", text: LEISURE_MEAL_TEXT },
    { key: "PROFESSIONAL", value: "PROFESSIONAL", text: PROFESSIONAL_MEAL_TEXT },
    { key: "FAST", value: "FAST", text: FAST_MEAL_TEXT },
    { key: "BIRTHDAY", value: "BIRTHDAY", text: BIRTHDAY_MEAL_TEXT },
    { key: "SPECIAL", value: "SPECIAL", text: SPECIAL_MEAL_TEXT },
    { key: "OTHER", value: "OTHER", text: OTHER_MEAL_TEXT },
];

// Reservation type of event constants
export const eventType = [
    { key: "LEISURE", value: "LEISURE", text: "Moment détente" },
    { key: "PROFESSIONAL", value: "PROFESSIONAL", text: "Repas professionnel" },
    { key: "FAST", value: "FAST", text: "Repas rapide" },
    { key: "BIRTHDAY", value: "BIRTHDAY", text: "Anniversaire" },
    { key: "SPECIAL", value: "SPECIAL", text: "Événement particulier" },
    { key: "OTHER", value: "OTHER", text: "Autre" },
];

// Months constants
export const selectMonth = [
    { key: "January", value: 1, text: "janvier" },
    { key: "February", value: 2, text: "février" },
    { key: "March", value: 3, text: "mars" },
    { key: "April", value: 4, text: "avril" },
    { key: "May", value: 5, text: "mai" },
    { key: "June", value: 6, text: "juin" },
    { key: "July", value: 7, text: "juillet" },
    { key: "August", value: 8, text: "aout" },
    { key: "September", value: 9, text: "septembre" },
    { key: "October", value: 10, text: "octobre" },
    { key: "November", value: 11, text: "novembre" },
    { key: "December", value: 12, text: "décembre" },
];

// Weekdays constants
export const weekDays = [
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
    "dimanche"
];

// Barestho marketing website
export const baresthoWebsite = "https://www.barestho.com";

// Step constants for the reservation form
export const reservationStep = "reservation";
export const detailStep = "detail";
export const contactStep = "contact";
export const summaryStep = "summary";

// Step constants for cancel/contact actions
export const GET_RESERVATION_FORM_STEP = "GET_RESERVATION_FORM_STEP";
export const SHOW_SUMMARY_STEP = "SHOW_SUMMARY_STEP";
export const DONE_STEP = "DONE_STEP";

// Regex for checking reservation form validity
export const dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
export const nameRegex = /^[a-zA-ZàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+(([',. -][a-zA-ZàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]{1})?[a-zA-ZàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]*)*$/;
export const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
export const belgianPhoneRegex = /^((\+|00)32\s?|0)4(60|[789]\d)(\s?\d{2}){3}$/;
export const frenchPhoneRegex = /^((\+|00)33\s?|0)[679](\s?\d{2}){4}$/;

// ORDERS
// countries
export const countriesOptions = [
    { key: "BE", value: "BE", text: "Belgique" },
    { key: "FR", value: "FR", text: "France" },
];

// CALENDAR STATUSES
export const CALENDAR = Object.freeze({
    PAST_DAY: "CALENDAR_PAST_DAY",
    NOT_IN_SHIFTS: "CALENDAR_NOT_IN_SHIFTS",
    BOOK_TIME_PASSED: "CALENDAR_BOOK_TIME_PASSED",
    PARTY_SIZE_TOO_BIG: "CALENDAR_PARTY_SIZE_TOO_BIG",
    SEATS_FOR_SMALLER_PARTY: "CALENDAR_SEATS_FOR_SMALLER_PARTY",
    NO_MORE_SEATS_FOR_PARTY: "CALENDAR_NO_MORE_SEATS_FOR_PARTY",
    VALID_STATE: "CALENDAR_VALID_STATE",
    CLOSED: "CALENDAR_CLOSED",
});

export const CALENDAR_MESSAGES = {
    CALENDAR_PAST_DAY: "Ce jour est passé.",
    CALENDAR_NOT_IN_SHIFTS: "Ce jour n'a pas de service.",
    CALENDAR_BOOK_TIME_PASSED: "Il n'est plus possible de réserver pour ce jour-ci.",
    CALENDAR_PARTY_SIZE_TOO_BIG: "Le nombre de personnes est supérieur au nombre de place disponibles par groupe.",
    CALENDAR_SEATS_FOR_SMALLER_PARTY: "Il n'y a plus de place pour votre taille de groupe, mais encore assez pour un groupe plus petit.",
    CALENDAR_NO_MORE_SEATS_FOR_PARTY: "Il n'y a plus de place disponible.",
    CALENDAR_VALID_STATE: "Jour valide.",
    CALENDAR_CLOSED: 'Fermé.',
};

// SHIFT STATUSES
export const SHIFT = Object.freeze({
    FULL: "SHIFT_FULL",
    AVAILABLE: "SHIFT_AVAILABLE",
    INFOS: "SHIFT_INFOS",
    CLOSED: "SHIFT_CLOSED",
    PARTY_SIZE_TOO_BIG: "SHIFT_PARTY_SIZE_TOO_BIG",
});

export const SHIFT_MESSAGES = {
    SHIFT_FULL: "Cette heure est complète.",
    SHIFT_AVAILABLE: "Heure valide.",
    SHIFT_INFOS: "Il n'est plus possible de réserver avec Barestho pour cette heure.",
    SHIFT_CLOSED: "Cette heure n'est plus disponible.",
    SHIFT_PARTY_SIZE_TOO_BIG: "Le nombre de personnes est supérieur au nombre de place disponibles par groupe pour cette heure.",
};

export const BARESTHO_SURVEY_QUESTIONS_DICT = {
    global_rating: {
        choices: [],
        type: "RATING",
        label: "Note globale",
        description: null,
        required: true,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
    },
    atmosphere_rating: {
        choices: [],
        type: "RATING",
        label: "Ambiance",
        description: null,
        required: true,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
    },
    service_rating: {
        choices: [],
        type: "RATING",
        label: "Qualité du service",
        description: null,
        required: true,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
    },
    quality_price_rating: {
        choices: [],
        type: "RATING",
        label: "Rapport qualité-prix",
        description: null,
        required: true,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
    },
    food_rating: {
        choices: [],
        type: "RATING",
        label: "Nourriture",
        description: null,
        required: true,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
        name:'food_rating',
    },
    average_price: {
        choices: [],
        type: "INTEGER",
        label: "Prix moyen par personne",
        description: null,
        required: false,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
        name:'comment',
    },
    comment: {
        choices: [],
        type: "TEXT",
        label: "Votre commentaire",
        description: null,
        required: false,
        explaination_required: false,
        disabled: false,
        locale: "fr",
        translation: null,
        name:'comment',
    },
};

export const BARESTHO_SURVEY_QUESTIONS = Object.entries(BARESTHO_SURVEY_QUESTIONS_DICT)
    .map(([key, value], position) => ({...value, name: key, position, className: `barestho-${value.type.toLowerCase()}`}));

export const DATE_FORMAT = "YYYY-MM-DD";


// WEBPACK FOOTER //
// ./src/constants.js